import RavelloService from '@/services/ravello'

export const CommunicationLogs = {
	name: 'Communication Logs',
	route: 'communication-logs',
}

export const CronJobs = {
	name: 'Cron Jobs',
	route: 'system-cron',
}

export const CronJob = {
	name: 'New job',
	route: 'system-cron-job',
	params: ['job'],
	lazyName: {
		fn: async job => (job === 'new'
			? null
			: RavelloService.get(`/v1/system/cron/${job}`)
		),
		params: ['job'],
		field: 'display_name',
	},
}

export const Events = {
	name: 'Events',
	route: 'events',
}

export const EventsScheduled = {
	name: 'Scheduled Events',
	route: 'events-scheduled',
}

export const EventsWorking = {
	name: 'Working Events',
	route: 'events-working',
}

export const Issues = {
	name: 'Issues',
	route: 'system-issues',
}

export const Jobs = {
	name: 'Jobs',
	route: 'jobs',
}

export const JobsWorking = {
	name: 'Working Jobs',
	route: 'jobs-working',
}

export const Status = {
	name: 'System Status',
	route: 'system-status',
}

export const Test = {
	name: 'Test',
	route: 'system-test',
}
